export const BUS_TRANSACTION_LIST_RESET_FILTERS =
  'BUS_TRANSACTION_LIST/RESET_FILTERS';

export default () => dispatch => {
  return dispatch({
    type: BUS_TRANSACTION_LIST_RESET_FILTERS,
  });
};
